// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Banner per lo stato offline */
.offline-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #333;
  color: white;
  padding: 8px 16px;
  text-align: center;
  z-index: 9999;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
}

.offline-icon {
  margin-right: 8px;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA,gCAAA;AACA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;AACF","sourcesContent":["/* Banner per lo stato offline */\n.offline-banner {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #333; // Un colore scuro per attirare l'attenzione\n  color: white;\n  padding: 8px 16px;\n  text-align: center;\n  z-index: 9999; // Un valore molto alto per stare sopra a tutto\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.offline-icon {\n  margin-right: 8px;\n  font-size: 18px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
